const initialState = {
  incomingCall: undefined,
  displayMini: false,
};

const call = (state = {}, action) => {
  switch (action.type) {
    case "MAKE_CALL": {
      return { ...state, outgoingCall: action.payload };
    }
    case "ANSWER_CALL": {
      return {
        ...state,
        currentCall: action.payload,
        outgoingCall: undefined,
        incomingCall: undefined,
      };
    }
    case "SET_INCOMING_CALL": {
      return { ...state, incomingCall: action.payload };
    }
    case "SET_OUTGOING_CALL": {
      return { ...state, outgoingCall: action.payload };
    }
    case "SET_CURRENT_CALL": {
      return {
        ...state,
        currentCall: action.payload,
        outgoingCall: undefined,
        incomingCall: undefined,
      };
    }
    case "REJECT_CALL": {
      return { ...state };
    }
    case "END_CALL": {
      return {
        ...state,
        currentCall: undefined,
        incomingCall: undefined,
        outgoingCall: undefined,
        displayMini: false,
      };
    }
    case "MARK_BUSY_CALL": {
      return { ...state };
    }
    case "MARK_NO_ANSWER_CALL": {
      return { ...state };
    }
    case "TOGGLE_DISPLAY_MINI": {
      return { ...state, displayMini: !state.displayMini };
    }
    case "SET_DISPLAY_MINI": {
      return { ...state, displayMini: action.payload };
    }
    default:
      return state;
  }
};

export default call;
